const POPUP_ERROR_MESSAGE_FF_LOCAL = 'newWindow is null';
const POPUP_ERROR_MESSAGE_FF = 'f is null';
const POPUP_ERRORS_TO_IGNORE = new Set([POPUP_ERROR_MESSAGE_FF_LOCAL, POPUP_ERROR_MESSAGE_FF]);
const lowercasedUserAgent = window.navigator ? navigator.userAgent.toLowerCase() : '';

const isEdge = () => {
  return lowercasedUserAgent.includes('edge/');
};

const isSafari = () => lowercasedUserAgent.includes('safari/') && !lowercasedUserAgent.includes('chrome/') && !isEdge();

const isIE = () => {
  return /Trident\/|MSIE/.test(window.navigator.userAgent);
};

export const doesSupportPopup = () => {
  return !isSafari() && !isIE();
};
export const isPopupError = message => {
  return POPUP_ERRORS_TO_IGNORE.has(message);
};